var listShowMore = function () {

    // Get the number of list items on load
    listSize = $('[data-more="list"] li').length;

    // Set the incremental view
    x = 10;

    // If the list is longer than 3 items show the 'More' button
    if (listSize > 10) {
        $('[data-more="button"]').show();
    }

    // Show the inital 3 items
    $('[data-more="list"] li:lt(' + x + ')').show();

    // When the user clicks show an additional 3 items
    $('[data-more="button"]').on('click', function () {
        x = (x + 10 <= listSize) ? x + 10 : listSize;
        $('[data-more="list"] li:lt(' + x + ')').show();

        // Keep a running total of shown items
        runningTotal = $('[data-more="list"] li:visible').length;

        // If the total equals the total list size hide the 'more' button, show the alert
        if (runningTotal === listSize) {
            $('[data-more="button"]').hide();
            $('[data-more="alert"]').show();
        }
    });

};

